<template>
  <div>
    <el-dialog
      title="Review Request"
      :visible="dialog_disabled"
      width="500px"
      top="3vh"
      :modal="true"
      @close="closeDialog()"
    >
      <p>Deleted at: {{selectedDisabled.deleted_at !== null  ? selectedDisabled.deleted_at : 'Queued for YT api delete'}}</p>
      <p v-if="selectedDisabled.requester">
        Requested by: <br>
        Name: <strong>{{selectedDisabled.requester.first_name}} {{selectedDisabled.requester.surname}}</strong> <br>
        Email: <strong>{{selectedDisabled.requester.email}}</strong>
      </p>
      <p>Channel info:</p>
      <div class="flex-center">
        <img :src="selectedDisabled.image_url" class="profile-photo">
      </div>
      <p>Channel title: <strong>{{selectedDisabled.title}}</strong><br>
        Channel ID: <strong>{{selectedDisabled.channelId}}</strong></p>
      <p>Reason:<br>
      <strong v-if="selectedDisabled.reason_for_add_request">{{selectedDisabled.reason_for_add_request}}</strong>
      <strong v-else-if="selectedDisabled.reason_for_delete_request">{{selectedDisabled.reason_for_delete_request}}</strong>
      <strong v-else>/</strong>
      </p>
      <p v-if="selectedDisabled.reason_for_rejection">Reason for rejection:<br>
        <strong v-if="selectedDisabled.reason_for_rejection">{{selectedDisabled.reason_for_rejection}}</strong>
        <strong v-else>/</strong>
      </p>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="closeDialog"
        >
          Close
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      reason: '',
      showReasonError: false
    }
  },
  computed: {
    ...mapState('youtubeWhitelist', ['dialog_disabled', "selectedDisabled", 'loading'])
  },

  methods: {
    ...mapActions('youtubeWhitelist', ['rejectDelete', "approveDelete", "approveInsert"]),
    ...mapMutations('youtubeWhitelist', ['setDialogDisabled', "setSelectedDisabled"]),

    closeDialog() {
      this.setDialogDisabled(false)
      this.setSelectedDisabled({})
      this.showReasonError = false;
      this.reason = ''
    }
  }
}
</script>
<style scoped>
.profile-photo {
  border-radius: 100%;
}

.errorinput >>> .el-textarea__inner {
  border-color: #d3162f;
}
.errortext{
  color: #d3162f;
}
</style>
